import React, { Component } from 'react'
import { getChamp } from '../../utils/champsFunctions'
import { getSwitchingsFromChamp } from '../../utils/confrontationsFunctions'

/* Components */
import ConfrontationSwitchingView from './ConfrontationSwitchingView'

class ConfrontationSwitching extends Component {
    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,

            loadingSwitchingList: true,
            switchingList: [],

            switchingId: null,
            isScoreMan: true,
        }
    }

    componentWillMount = async () => {
        let arrayOfRoute = this.props.location.pathname.split('/')

        // Get specific champ object
        const champId = arrayOfRoute[3];
        const champ = await getChamp(champId);
        this.setState({
            champObject: champ,
            champId,
        });

        // Get list of switchings
        let localArrayOfswitching = []
        for (let i = 0; i < 313; i++) {
            localArrayOfswitching.push({ 'n': i, 'color': '' })
        }
        // Get color of switchings
        const snap = await getSwitchingsFromChamp(champId);
        snap.forEach(childSnap => {
            if (localArrayOfswitching[childSnap.__key])
                localArrayOfswitching[childSnap.__key - 1]['color'] = childSnap.faixa
        })
        this.setState({
            switchingList: localArrayOfswitching,
            loadingSwitchingList: false,
        });

        // Check if user came from scoreboard
        if (this.props.location.state && this.props.location.state.switchingId) {
            this.chooseSwitching(this.props.location.state.switchingId)
        }
    }

    chooseSwitching = (value) => {
        this.setState({
            switchingId: value
        })
    }

    render() {
        return (
            <ConfrontationSwitchingView
                champObject={this.state.champObject}
                champId={this.state.champId}

                loadingSwitchingList={this.state.loadingSwitchingList}
                switchingList={this.state.switchingList}
                chooseSwitching={e => this.chooseSwitching(e)}

                switchingId={this.state.switchingId}
                isScoreMan={this.state.isScoreMan}
            />
        )
    }
}

export default ConfrontationSwitching